import { QueryKeyConfig, MutationKeyConfig } from '../api-helper';

export const divisionApiKeyStore = {
  createDivision: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_DIVISION`],
    route: `/Division`,
    action: 'POST',
  }),
  updateDivision: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_DIVISION`],
    route: `/Division`,
    action: 'PUT',
  }),
  deleteDivision: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_DIVISION`, id],
    route: `/Division/${id}`,
    action: 'DELETE',
  }),
  getDivisions: (): QueryKeyConfig => ({
    queryKey: [`GET_DIVISIONS`],
    route: `/Division`,
  }),
  getCustomerDivisions: (customerID: number): QueryKeyConfig => ({
    queryKey: [`GET_CUSTOMER_DIVISIONS`, customerID],
    route: `/Division/Mappings?CustomerID=${customerID}`,
    isEnabled: !!customerID && customerID >= 0,
  }),
  getOfficeDivisions: (officeID: number): QueryKeyConfig => ({
    queryKey: [`GET_OFFICE_DIVISIONS`, officeID],
    route: `/Division/Mappings?OfficeID=${officeID}`,
    isEnabled: !!officeID && officeID >= 0,
  }),
  getProjectDivisions: (projectID: number): QueryKeyConfig => ({
    queryKey: [`GET_PROJECT_DIVISIONS`, projectID],
    route: `/Division/Mappings?ProjectID=${projectID}`,
    isEnabled: !!projectID && projectID >= 0,
  }),
};
